import { connect } from 'react-redux';
import { currentUserSelectors, contactSelectors, userProfileSelectors } from '@lifesize/nucleus';
import { addNotification } from 'actions/Notification';
import JoinModal from 'components/JoinModal/JoinModal';
import _get from 'lodash/get';

const mapStateToProps = (state, ownProps) => {
  const currentUserInfo = currentUserSelectors.myInfo(state);
  const userName = _get(currentUserInfo, 'name') || _get(state, 'nucleus.auth.credentials.guestName');
  const isAcquiringPrimaryStream = _get(state, 'nucleus.media.isAcquiringPrimaryStream');
  const isGuest = userProfileSelectors.selectIsGuest(state);
  const remoteContact =
    contactSelectors.getContactByDialStringGenerator(state)(ownProps.extension) ||
    { name: ownProps.extension };

  return ({
    userName,
    isAcquiringPrimaryStream,
    remoteContact,
    isGuest
  });
};

const mapDispatchToProps = dispatch => ({
  addNotification: (type, props) => {
    dispatch(addNotification(type, props));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(JoinModal);
